/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'team-central.give-jira-kudos.created.description.flag': 'A munkahelyi környezettel foglalkozó csapatunk most fel fogja dolgozni az ajándékkérelmet. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Dicséret létrehozva',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Nem sikerült létrehozni a dicséretedet és elküldeni az ajándékot. Próbálj meg egy külön jegyet indítani a <a>go/kudos</a> oldalon.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Hiba történt',
  'team-central.give-kudos.button': 'Dicséret',
  'team-central.give-kudos.close-button.label': 'Fiók bezárása',
  'team-central.give-kudos.confirm-close.title': 'Bezárás megerősítése',
  'team-central.give-kudos.created.description.flag': 'Dicséret elküldve. <a>Dicséret megtekintése</a>',
  'team-central.give-kudos.created.title.flag': 'Dicséret létrehozva',
  'team-central.give-kudos.creation.failed.description.flag': 'Nem sikerült létrehozni a dicséretedet.',
  'team-central.give-kudos.creation.failed.title.flag': 'Hiba történt',
  'team-central.give-kudos.error-icon.label': 'Hiba',
  'team-central.give-kudos.success-icon.label': 'Sikerült',
  'team-central.give-kudos.unsaved.warning': 'A módosításaidat nem mentjük.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Mégse',
  'team-central.give-kudos.unsaved.warning.close': 'Bezárás'
};